import React from 'react';
import { withSessionSsr, getPublicToken } from "../../lib/sessionMiddleware";
import { getCanonicalPath } from "../../lib/canonical";
import useHook from '../../hooks/pages/ingresar/useHook';
import styles from './styles.module.scss';
import {
  Navbar,
  Wrapper,
  TituloSeccion,
  Seccion,
  Footer,
  Loader,
  HeadTags,
  BtnFlotanteWhatsapp,
  Container,
  Link,
  Turnstile,
}from '../../components';

import {
  Button,
  useTheme,
  Grid,
  FormControl,
  TextField,
  InputAdornment,
  IconButton,
  Alert,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const IngresarPage = (props)=>{

  const contenido = props.pageProps.contenido;

  const theme = useTheme();

  const {
    mobile,
    loading,
    handleSubmit,
    email,
    handleEmail,
    feedbackEmail,
    password,
    handlePassword,
    showPassword,
    setShowPassword,
    feedbackType,
    feedbackMessage,
    handleRecuperarCuenta,
    turnstileRef,
    handleTurnstileVerify,
    handleTurnstileExpire,
    turnstileToken,
  } = useHook();
    
  return(<>

    <HeadTags  
      title="Iniciar sesión" 
      description=""
      path={props.pageProps.pathname}
    />

    <Navbar/>

    <Seccion padding="40px 20px" paddingMobile="20px">
      <Wrapper>             
        <TituloSeccion align="center">Iniciar sesión</TituloSeccion>
        <br/><br/>
        <Container width="340px">
          <form className={styles.form} onSubmit={(e)=>handleSubmit(e)}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={12}>
                <FormControl fullWidth>                       
                  <TextField 
                    fullWidth
                    id="email" 
                    label="Email" 
                    variant="outlined" 
                    type="email"
                    value={email}
                    error={Boolean(feedbackEmail)}
                    helperText={feedbackEmail}
                    autoComplete="current-email"   
                    color="secondary"                                     
                    onChange={(e)=>handleEmail(e.target.value)}
                    InputProps={{
                      style: { 
                        borderRadius: "100px",
                        background: "#fff",
                        padding: "0 6px"
                      },
                    }}                                        
                  />     
                </FormControl>      
              </Grid>    
              <Grid item xs={12} md={12}>
                <FormControl fullWidth>                        
                  <TextField 
                    fullWidth
                    id="password" 
                    label="Password" 
                    variant="outlined" 
                    type={!showPassword ? 'password' : 'text'}
                    value={password}
                    color="secondary"
                    autoComplete="current-password"
                    onChange={(e)=>handlePassword(e.target.value)}
                    InputProps={{
                      style: { 
                        borderRadius: "100px",
                        background: "#fff",
                        padding: "0 6px"
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                            style={{
                              marginRight: "12px"
                            }}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}                                    
                  />          
                </FormControl>
              </Grid>
              {!!feedbackMessage && <Grid item xs={12} md={12}>
                <Alert severity={feedbackType}>{feedbackMessage}</Alert>
                {feedbackType === "error" && <Alert severity="info" style={{marginTop: "8px"}}>
                                    ¿Problemas para ingresar?
                  <div style={{margin: "8px 0"}}>
                    <Turnstile ref={turnstileRef} onVerify={handleTurnstileVerify} onExpire={handleTurnstileExpire} />
                  </div>
                  <u
                    onClick={handleRecuperarCuenta}
                    style={{
                      margin: "6px",
                      cursor: turnstileToken ? "pointer" : "not-allowed",
                      opacity: turnstileToken ? 1 : 0.5,
                    }}
                  >Recuperá tu cuenta</u>
                </Alert>}
              </Grid>}
              <Grid item xs={12} md={12}>
                <FormControl fullWidth>
                  <Button
                    color="otherPink2"
                    variant="contained"
                    style={{
                      padding: "16px 36px"
                    }}
                    disabled={
                      (!Boolean(email) || Boolean(feedbackEmail))
                                            || !Boolean(password)
                                            || loading
                    }
                    type="submit"
                  >Ingresar</Button>
                </FormControl>
              </Grid>

            </Grid>
            <br/><br/>
            <div style={{textAlign: "center"}}>
              <Link href="/registrarse">¿Aún no tenés cuenta?</Link>
            </div>
          </form>
        </Container>

      </Wrapper>
    </Seccion>

    <br/><br/><br/>

    <Footer/>

    <BtnFlotanteWhatsapp/>
  </>);
};

export default IngresarPage;

export const getServerSideProps = withSessionSsr(
  async function getServerSideProps(ctx) {
  
    const { req } = ctx;
        
    const publicToken = await getPublicToken(req);
    // página para usuario NO loggeados
    if (req.session.user) {
      return {
        redirect: {
          destination: `/mi-cuenta`,
          permanent: false, 
        },
      };
    }   

    return {
      props: {
        pathname: getCanonicalPath(req),
      },
    };    
  
  },
);